import { IClassname } from '@/lib/shared/model/classname';

export const Lift = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14276_567)">
        <path
          d="M3.22079 1.31348H28.7791C28.7791 1.31348 30.057 1.31348 30.057 2.59139V29.4276C30.057 29.4276 30.057 30.7056 28.7791 30.7056H3.22079C3.22079 30.7056 1.94287 30.7056 1.94287 29.4276V2.59139C1.94287 2.59139 1.94287 1.31348 3.22079 1.31348Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 30.7055V10.2588"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.9455 30.7055V10.8977C24.9455 10.8138 24.929 10.7307 24.8969 10.6532C24.8648 10.5757 24.8177 10.5053 24.7584 10.4459C24.699 10.3866 24.6286 10.3395 24.5511 10.3074C24.4736 10.2753 24.3905 10.2588 24.3066 10.2588H7.69365C7.52418 10.2588 7.36166 10.3261 7.24183 10.4459C7.12201 10.5658 7.05469 10.7283 7.05469 10.8977V30.7055"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.61035 7.06432L11.0748 5.59983C11.1342 5.54032 11.2047 5.49311 11.2823 5.4609C11.36 5.42869 11.4432 5.41211 11.5272 5.41211C11.6113 5.41211 11.6945 5.42869 11.7721 5.4609C11.8497 5.49311 11.9203 5.54032 11.9796 5.59983L13.4441 7.06432"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5559 5.14746L20.0204 6.61195C20.0798 6.67146 20.1503 6.71867 20.2279 6.75088C20.3055 6.78309 20.3887 6.79967 20.4728 6.79967C20.5568 6.79967 20.64 6.78309 20.7177 6.75088C20.7953 6.71867 20.8658 6.67146 20.9252 6.61195L22.3897 5.14746"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14276_567">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.00976562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
